import { httpCall } from '@/common/util';
import config from './enpoints';

export const getWorkkardListingTabCount = () => {
  return httpCall({
    method: 'GET',
    headers: { "Content-Type": "application/json" },
    url: `${config.api.endpoints.tabCounts}`,
  });
};

export const getWorkkardListingData = (isListView, payload) => {
  const endpoint = isListView
    ? config.api.endpoints.listView
    : config.api.endpoints.cardView;
  
  return httpCall({
    method: 'GET',
    headers: { "Content-Type": "application/json" },
    params: payload,
    url: `${endpoint}`,
  });
};